import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/Button.css';

// Navigates to sign up pgae
const SignupButton = () => {
    return (
        <Link to="/signup" className="signup-button">
            Sign Up
        </Link>
    );
};

export default SignupButton;
